export default {
  title: 'Países',
  importExport: 'Importar/Exportar',
  countriesConfig: 'Configuração de Países',
  close: 'Fechar',
  save: 'Salvar',
  json: 'JSON',
  noData: 'Sem dados',
  headerName: 'Nome',
  headerIsoCode: 'Código ISO',
  headerTrpCost: 'Custo TRP',
  headerWeeklyMinSpend: 'Investimento Mín. Semanal',
  validationJsonRequired: 'O JSON é obrigatório',
  validationInvalidJson: 'JSON inválido',
  validationInvalidCountries: 'Países inválidos'
}
